import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  resultTitle: {
    id: 'product_jp_page_customization_result_title',
    defaultMessage: 'Here is the item you selected',
  },
  addToCart: {
    id: 'product_page_add_to_cart',
    defaultMessage: 'Add to cart',
  },
} as Record<string, I18nDefinition>
